import { defaultBearColor } from "config";
import React from "react";

export type DressingRoomContextValue = {
  tokenId?: number;
  color: number;
  currentTraits: number[];
  initialTraits: number[];
  availableTraits?: number[];
  newTraits?: number[];
  canRedo: boolean;
  canUndo: boolean;
  undoSwap: () => void;
  redoSwap: () => void;
  resetTraits: () => void;
  removeTrait: (traitId: number) => void;
  swapTrait: (newTraits: number[]) => void;
};

const DressingRoomContext = React.createContext<DressingRoomContextValue>({
  color: defaultBearColor,
  currentTraits: [],
  initialTraits: [],
  canRedo: false,
  canUndo: false,
  undoSwap: () => {},
  redoSwap: () => {},
  resetTraits: () => {},
  swapTrait: () => {},
  removeTrait: () => {},
});

export default DressingRoomContext;
